import React from "react"

import CodeBlock from "../components/code-block"

export default {
  pre: ({ children }) => <CodeBlock>{children}</CodeBlock>,
}
